let appHistory = null;

const normalizeHref = (href) => {
  if (!href) {
    return `${window.location.pathname}${window.location.search}${window.location.hash}`;
  }
  const url = new URL(href, window.location.origin);
  return `${url.pathname}${url.search}${url.hash}`;
};

const applyWindowHistory = (mode, href, state = {page: window.history.length}) => {
  const method = mode === 'replace' ? 'replaceState' : 'pushState';
  window.history[method](state, null, href);
};

export const setAppHistory = (history) => {
  appHistory = history || null;
};

export const navigate = (href, mode = 'push', state) => {
  const normalizedHref = normalizeHref(href);
  const method = mode === 'replace' ? 'replace' : 'push';
  if (appHistory && typeof appHistory[method] === 'function') {
    try {
      appHistory[method](normalizedHref, state);
      return;
    }
    catch (error) {
      // Redux throws "Reducers may not dispatch actions" (#9) when a navigation
      // attempted synchronously inside a reducer triggers a history listener that
      // dispatches (e.g. UrlQueryApplier reacting to the URL change). Production
      // React/Redux builds MINIFY that message to "Minified Redux error #9;
      // visit https://redux.js.org/Errors?code=9 …", so matching only the full
      // text silently broke this guard in prod builds — re-throwing the nested
      // dispatch as an uncaught error. Match both the full and minified forms.
      const message = error?.message || '';
      const isNestedDispatchError = /Reducers may not dispatch actions/i.test(message)
        || /Minified Redux error #?9\b/i.test(message)
        || /redux\.js\.org\/Errors\?code=9\b/i.test(message);
      if (!isNestedDispatchError) {
        throw error;
      }
      // Navigation was attempted synchronously inside a reducer dispatch.
      // Defer it so it still routes through react-router (which re-renders
      // <Routes>) instead of falling back to a raw window.history call that
      // changes the URL without updating the router.
      setTimeout(() => {
        // These deferred writes are query-param edits (e.g. resetMapSearchResults clearing
        // filters from a reducer). The href bakes in the pathname captured at dispatch time.
        // If a real navigation changed the pathname before this fires (e.g. clicking a
        // Country/State breadcrumb pushes /country/us while a reset was deferred), applying
        // the stale replace would revert the URL back to the old page. The new page already
        // owns a clean URL, so the param edit is moot — skip it.
        if (method === 'replace') {
          const deferredPath = new URL(normalizedHref, window.location.origin).pathname;
          if (deferredPath !== window.location.pathname) {
            return;
          }
        }
        appHistory[method](normalizedHref, state);
      }, 0);
      return;
    }
  }
  applyWindowHistory(method, normalizedHref, state);
};

export const replaceHash = (hash) => {
  const normalizedHash = hash?.startsWith('#') ? hash : `#${hash || ''}`;
  const href = `${window.location.pathname}${window.location.search}${normalizedHash}`;
  navigate(href, 'replace', window.history.state);
};
